import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { VbUiSidebarComponent } from './VbUiSidebar.Component';
import styles from './VbUiSidebar.Component.module.less';
import { StateService } from '@uirouter/angular';

@Component({
	selector: 'vb-ui-sidebar-button',
	template: `
		<button #button
			type="button"
			role="tab"
			[ngClass]="styles.sidebarButton"
			[class.active]="isActive"
			[attr.aria-selected]="isActive"
			[disabled]="disabled"
			[tooltip]="headerLabel"
			[containerClass]="styles.tooltipContainer + ' ' +
				(sidebar.smallButtons ? styles.mobileSidebar : '')"
			container="body"
			tabindex="-1"
			(click)="onClick($event)"
			(keydown.arrowup)="moveFocus($event, true)"
			(keydown.arrowdown)="moveFocus($event)"
			(keydown.arrowleft)="moveFocus($event, true)"
			(keydown.arrowright)="moveFocus($event)">
			<ng-content></ng-content>
		</button>
	`,
	standalone: false
})
export class VbUiSidebarButtonComponent implements OnInit {
	@Input() public id: string;
	@Input() public headerLabel: string;
	@Input() public sref: string;
	@Input() public srefOpts: any;
	@Input() public activeOnVisible: boolean;
	@Input() public disabled: boolean;
	/** Binds to native button click for accessibility. When used, the tab panel will not be opened*/
	@Output() public action = new EventEmitter<MouseEvent>();
	public readonly styles = styles;

	@ViewChild('button') public button: ElementRef<HTMLButtonElement>;

	constructor(
		public sidebar: VbUiSidebarComponent,
		public $state: StateService
	){
	}

	public ngOnInit(): void {
		if(this.activeOnVisible) {
			setTimeout(() => this.sidebar.onClick(this.id), 100);
		}
	}

	public get isActive() {
		return this === this.sidebar.activeButton();
	}

	public moveFocus(e: FocusEvent, reverse?: boolean) {
		this.sidebar.moveFocus(reverse);
		e.preventDefault();
	}

	public onClick(e: MouseEvent): void {
		this.action.emit(e);

		if(this.sref) {
			const url = this.$state.href(this.sref, this.srefOpts);
			window.open(url, '_blank');
			e.preventDefault();
			return;
		}
		if(!this.action.observed) {
			this.sidebar.onClick(this.id);
		}
	}
}
